module.exports = __webpack_public_path__ + "static/media/table_widget_icon.d56786ab.svg";